import script from "./remark-mentions-hint.vue?vue&type=script&setup=true&lang=ts"
export * from "./remark-mentions-hint.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__